import { render, staticRenderFns } from "./StoryForm.vue?vue&type=template&id=bf285ac4&scoped=true&"
import script from "./StoryForm.vue?vue&type=script&lang=js&"
export * from "./StoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf285ac4",
  null
  
)

export default component.exports